var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccurrence({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#191919"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 39,
    fill: "current"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 36,
    fill: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8125 52C37.0206 52 38 51.0206 38 49.8125C38 48.6044 37.0206 47.625 35.8125 47.625C34.6044 47.625 33.625 48.6044 33.625 49.8125C33.625 51.0206 34.6044 52 35.8125 52Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1875 52C55.3956 52 56.375 51.0206 56.375 49.8125C56.375 48.6044 55.3956 47.625 54.1875 47.625C52.9794 47.625 52 48.6044 52 49.8125C52 51.0206 52.9794 52 54.1875 52Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 56.375C28.6753 56.375 27.5 55.1998 27.5 53.75V45.621C27.5 43.6318 28.6243 41.8133 30.4038 40.9244L31.0005 40.6263L33.0217 31.9554C33.391 30.371 34.8034 29.25 36.4303 29.25H53.6575C55.2966 29.25 56.7162 30.3875 57.0733 31.9871L59.0027 40.6263L59.598 40.9239C61.3765 41.8133 62.5 43.6311 62.5 45.6196V53.75C62.5 55.1998 61.3248 56.375 59.875 56.375H58.1277V57.25C58.1277 59.183 56.5594 60.75 54.6264 60.75C52.6934 60.75 51.125 59.183 51.125 57.25V56.375H38.875V57.2503C38.875 59.1831 37.3081 60.75 35.3753 60.75C33.4424 60.75 31.8755 59.1831 31.8755 57.2503V56.375H30.125Z",
    stroke: "current",
    strokeWidth: 1.96875,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 43.25H53.75L52.3045 36.7453C52.1266 35.9447 51.4165 35.375 50.5962 35.375H39.4038C38.5835 35.375 37.8734 35.9447 37.6955 36.7453L36.25 43.25Z",
    stroke: "current",
    strokeWidth: 1.96875,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccurrence);
export default __webpack_public_path__ + "static/media/occurrence.8f967b16efd3dc1720402b0e413b0d28.svg";
export { ForwardRef as ReactComponent };